module.exports = __webpack_public_path__ + "static/health-51f38c979ff9ae2271e304f4ca238a01.png";